import React from 'react'
import TabsComp from '../components/TabsComp'

const AdminPanel = () => {
  return (
    <div>
      <TabsComp />
    </div>
  )
}

export default AdminPanel